import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="/about/">À propos</Link>
        </li>
        <li>
          <a href="https://rider.gorider.co">Devenir coursier</a>
        </li>
        <li>
          <a href="https://docs.gorider.co">Solution API</a>
        </li>
        <li>
          <Link to="/legal/">Mentions Légales</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;